export class BlobURLManager {
    constructor() {
        this.activeURLs = new Set();
        this.urlToBlob = new Map();
    }
    createObjectURL(blob) {
        const url = URL.createObjectURL(blob);
        this.activeURLs.add(url);
        this.urlToBlob.set(url, blob);
        return url;
    }
    revokeObjectURL(url) {
        if (this.activeURLs.has(url)) {
            URL.revokeObjectURL(url);
            this.activeURLs.delete(url);
            this.urlToBlob.delete(url);
        }
    }
    revokeAllURLs() {
        this.activeURLs.forEach((url) => {
            URL.revokeObjectURL(url);
        });
        this.activeURLs.clear();
        this.urlToBlob.clear();
    }
    getActiveURLCount() {
        return this.activeURLs.size;
    }
    hasURL(url) {
        return this.activeURLs.has(url);
    }
}
